import { connect } from 'react-redux';
import { compose } from 'utils/react';
import { bulkManage as bulkManageHostnames } from 'store/modules/hostnames';
import { load as loadApp } from 'store/modules/app';
import RedirectSettings from '../components/RedirectSettings';

export default compose(
  connect(
    ({ hostnames }) => ({
      hostnames: hostnames.items,
      isSaving: hostnames.saving,
      error: hostnames.saveError,
    }),
    { onSave: bulkManageHostnames, reloadApp: loadApp },
  ),
)(RedirectSettings);
